function i(t){return typeof t=="bigint"}export{i as a};
